<template>
    <div>
        <Tabs style="border-bottom: 1px solid rgb(235, 238, 245);" value="html" @on-click="changechannel" ref="tabs">
           <TabPane label="网页" name="html">
                <div class="fixed_search">
                  <div class="fixed_search_input">
                    <Input v-model="channelName" placeholder="请输入网页名称" clearable/>
                  </div>
                  <div class="fixed_operation_btn" style="width: auto">
                    <Button type="primary" @click="initSearch">查询</Button>
                    <Button v-if="roleList['3_12-1-5']" type="info" @click="addWebpage">添加</Button>
                  </div>
                </div>
                <div class="fixed_table" :style="tableHeight">
                          <el-table :data="contentList" style="width: 100%"  class="element_table" :class="{'tableClass':tableClass}" slot="empty">
                            <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                            <el-table-column  fixed="right" label="操作" v-if="contentList.length>0"  align="center">
                              <template slot-scope="scope">
                                <el-button v-if="roleList['3_12-1-1']" @click="insertCode(scope.row.id,scope.row.channelWxToken)" type="text" size="small">代码</el-button>
                                <el-button v-if="roleList['3_12-1-2']" @click="editpage(scope.row.id,scope.row.channelName)"  type="text" size="small">编辑</el-button>
                                <el-button v-if="roleList['3_12-1-3']" type="text" size="small" @click="doDelete(scope.row.id)">删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                </div>
           </TabPane>
           <TabPane label="微信" name="wx">
                <div class="fixed_search">
                  <div class="fixed_search_input">
                    <Input v-model="publicChannelName" placeholder="请输入公众号名称" clearable/>
                  </div>
                  <div class="fixed_operation_btn" style="width: auto">
                    <Button type="primary" @click="initSearch">查询</Button>
                    <Button v-if="roleList['3_12-1-6']" type="info" @click="addpublic">绑定公众号</Button>
                  </div>
                </div>
                <div class="fixed_table" :style="tableHeight">
                          <el-table :data="contentList" style="width: 100%" class="element_table" :class="{'tableClass':tableClass}"  >
                            <el-table-column v-for="(item,index) in weChatfieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                            <el-table-column  fixed="right" label="操作" v-if="contentList.length>0"  align="center">
                              <template slot-scope="scope">
                                <el-button v-if="roleList['3_12-1-4']" type="text" size="small"  @click="setcustom(scope.row.id)">自定义菜单</el-button>
                                <el-button v-if="roleList['3_12-1-2']" type="text" size="small" @click="editpublic(scope.row.id)">编辑</el-button>
                                <el-button v-if="roleList['3_12-1-3']" type="text" size="small" @click="doDelete(scope.row.id)">删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                </div>
           </TabPane>
           <TabPane label="" name="mini" disabled>
                <div class="fixed_search">
                  <div class="fixed_search_input">
                    <Input v-model="channelName" placeholder="请输入小程序名称" />
                  </div>
                  <div class="fixed_operation_btn" style="width: auto">
                    <Button type="primary" @click = "initSearch">查询</Button>
                    <Button v-if="roleList['3_12-1-7']" type="info" @click = "addpublic">绑定小程序</Button>
                  </div>
                </div>
                <div class="fixed_table" :style="tableHeight">
                          <el-table :data="contentList" style="width: 100%" class="element_table" :class="{'tableClass':tableClass}" >
                            <el-table-column v-for="(item,index) in minifieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                            <el-table-column  fixed="right" label="操作" v-if="contentList.length>0"  align="center">
                              <template slot-scope="scope">
                                <el-button v-if="roleList['3_12-1-2']" type="text" size="small" >编辑</el-button>
                                <el-button v-if="roleList['3_12-1-3']" type="text" size="small" >删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                </div>
           </TabPane>
        </Tabs>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
         <InsertpagePop :showInsertpage="showInsertpage" :searchId="searchId" :seachName="seachName" @closeInsertpage="closeInsertpage"></InsertpagePop>
         <WechatpublicPop :showWechatpublic="showWechatpublic" :channelType="tabType" @closeWechatpublic="closeWechatpublic"></WechatpublicPop>
         <DeveloperPop :showDeveloper="showDeveloper" :channelType="tabType" @closeDeveloper="closeDeveloper"></DeveloperPop>
         <EditpublicPop :showeditpublic="showeditpublic" :searchId="searchId" @closeeditpublic="closeeditpublic"></EditpublicPop>
         <CustommenuPop :showcustommenu="showcustommenu" :searchId="searchId" @closecustommenu="closecustommenu"></CustommenuPop>
         <CodeInsertPop :showCodeInsert="showCodeInsert" :searchId="searchId" :inToken="inToken" @closeCodeInsert="closeCodeInsert"></CodeInsertPop>
    </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import InsertpagePop from '@/components/systemSetup/DialogueConfigure/InsertpagePop.vue'
  import WechatpublicPop from '@/components/systemSetup/DialogueConfigure/WechatpublicPop.vue'
  import DeveloperPop from '@/components/systemSetup/DialogueConfigure/DeveloperPop.vue'
  import EditpublicPop from '@/components/systemSetup/DialogueConfigure/EditpublicPop.vue'
  import CustommenuPop from '@/components/systemSetup/DialogueConfigure/CustommenuPop.vue'
  import CodeInsertPop from '@/components/systemSetup/DialogueConfigure/CodeInsertPop.vue'
  export default {
    name: "ChannelManage",
    mixins:[publicFunClass],
    components:{
      InsertpagePop,
      WechatpublicPop,
      DeveloperPop,
      EditpublicPop,
      CustommenuPop,
      CodeInsertPop
    },
    props:{
      pageCode:String
    },
    data(){
      return{
        showPageCount:0,
        spinShow:false,
        tableClass: true,
        tabType: "-7", //第一次默认加载wx
        channelName:'',//网页名称
        publicChannelName:'',
        contentList: [],
        fieldList: [
          {key:'channelName','title':'网页名称'},{key:'channelPeriod','title':'分时段'},
          {key:'channelAllocatStrategy','title':'分配策略'},{key:'btnName','title':'按钮名称'}
        ],
        showInsertpage:false,
        searchId:'',
        seachName:'',
        inToken:'',
        weChatfieldList: [
          {key:'channelName','title':'公众号名称'},{key:'channelMode','title':'接入方式'},{key:'channelPeriod','title':'分时段'},
          {key:'channelAllocatStrategy','title':'分配策略'}
        ],
        minifieldList: [
          {key:'channelName','title':'小程序名称'},{key:'channelMode','title':'接入方式'},{key:'channelPeriod','title':'分时段'},
          {key:'channelAllocatStrategy','title':'分配策略'}
        ],


        showWechatpublic:false,
        showDeveloper:false,
        showeditpublic:false,
        showcustommenu:false,
        showCodeInsert:false,

        tableHeight:{height:''},
        total: 0,
        pageSizeList:[10,20,30,40,50,100,200],
        speedChangePage: 1,
        currentPage:1,
        pageSize:20,
        roleList: JSON.parse(localStorage.getItem("roleList")),
      }
    },
    methods:{
        changechannel:function(tabName){//切换tab页
          if ("html" == tabName){
            this.tabType = "-7";
          }else if ("wx" == tabName){
            this.tabType = "-8";
          }else if ("mini" == tabName){
            this.tabType = "-9";
          }
          this.initSearch();
        },
        //网页相关
         closeInsertpage:function(flag){
            this.showInsertpage=false;
            if(flag){
              this.initSearch();
            }
          },
         addWebpage:function () {
          this.searchId="";
          this.showInsertpage=true;
         },
         editpage:function (id,name) {
            this.searchId=id;
            this.seachName=name,
            this.showInsertpage=true;
        },
        // 初始化查询
        initSearch: function(){
          if(this.tabType == "-7"){//网页

            let param = {
                channelType: this.tabType,
                channelName: this.channelName,
                journalType: "系统管理=>会话配置=>渠道管理=>查询",
                menuId: "3_12-1",
                pageNum:this.currentPage,
                pageSize:this.pageSize,
              }
              let that = this;
              this.spinShow = true
              this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
                let result=res.data;
                that.spinShow=false;
                if(result.flag!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                that.total=res.data.obj.list.totalSize;
                that.contentList=res.data.obj.list.content;
            })

          }else if(this.tabType == "-8"){//微信
              let param = {
                    channelType: this.tabType,
                    channelName: this.publicChannelName,
                    journalType: "系统管理=>会话配置=>渠道管理=>查询",
                    menuId: "3_12-1",
                    pageNum:this.currentPage,
                    pageSize:this.pageSize,
                }
                let that = this;
                this.spinShow = true
                this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
                  let result=res.data;
                  that.spinShow=false;
                  if(result.flag!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    return false;
                  }
                  that.total=res.data.obj.list.totalSize;
                  that.contentList=res.data.obj.list.content;
              })
          }


        },
        // 删除
        doDelete: function(id){
          let param = {
            id: id,
            journalType: "系统管理=>会话配置=>渠道管理=>删除",
            menuId: "3_12-1-3"
          }
          let that = this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定删除",
            onOk: () => {
              this.$http.post("chat/channel/doDelete.json",param) .then(function (res) {
                let result=res.data;
                that.spinShow=false;
                if(result.flag!="666"){
                  that.$Message.error(result.msg);
                  return false;
                }
                that.$Message.success(res.data.msg);
                that.initSearch();
              })
            }
          });

        },

         closeWechatpublic:function (flag,value) {
            this.showWechatpublic=false;
            if(value=='2'){
                this.showDeveloper=true;
            }
         },
         addpublic:function () {
           // this.showWechatpublic=true;
            this.showDeveloper=true;
         },
         closeDeveloper:function (flag) {
             this.showDeveloper=false;
             if(flag){
               this.initSearch();
             }
         },
         editpublic:function (id) {
           this.searchId = id;
           this.showeditpublic=true;
         },
          closeeditpublic:function (flag) {
             this.showeditpublic=false;
             if(flag){
               this.initSearch();
             }
         },
         setcustom:function (id) {
            this.searchId = id;
            this.showcustommenu=true;
         },
         closecustommenu:function () {
              this.showcustommenu=false;
         },

         closeCodeInsert:function(){
            this.showCodeInsert=false;
         },
         insertCode:function(id,token) {
            this.searchId = id;
            this.inToken=token;
            this.showCodeInsert=true;
         }
    },
    created(){
        this.tableHeight.height=this.mountHeight(234);
        this.initSearch();
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_12-1' && this.showPageCount==0){
          this.showPageCount++;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/ChannelManage.vue